type Tone = "accent" | "viola" | "poolblue" | "ink";
type Size = "sm" | "md";

type Props = {
  children: React.ReactNode;
  tone?: Tone;
  size?: Size;
  className?: string;
};

const tones: Record<Tone, string> = {
  accent: "bg-accent/10 text-accent",
  viola: "bg-raytio-viola/15 text-raytio-viola-text dark:text-raytio-viola",
  poolblue:
    "bg-raytio-poolblue/15 text-raytio-poolblue-text dark:text-raytio-poolblue",
  // For use on dark bands: subtle white-tinted tile.
  ink: "bg-white/10 text-accent",
};

const sizes: Record<Size, string> = {
  sm: "h-10 w-10 rounded-lg",
  md: "h-12 w-12 rounded-xl",
};

/** Rounded-square tinted container for a single icon. */
export const IconTile = ({
  children,
  tone = "accent",
  size = "md",
  className = "",
}: Props) => (
  <span
    className={`inline-flex items-center justify-center ${sizes[size]} ${tones[tone]} ${className}`}
  >
    {children}
  </span>
);
